import { RichTextEditor } from "@mantine/tiptap"
import React, { useState } from "react"
import { Icon } from "@/components"
import type { Editor } from "@tiptap/core"
import { Extension } from "@tiptap/core"
import { Textarea } from "@mantine/core"
import { useStyles } from "./RichTextCodeView.style"

export const RichTextCodeView = Extension.create({
    name: "codeView",

    addOptions() {
        return {
            onChange: () => undefined,
        }
    },

    addStorage() {
        return {
            enabled: false,
            rawHtml: "",
        }
    },

    addCommands() {
        return {
            toggleCodeView:
                () =>
                ({ editor }) => {
                    if (editor.extensionStorage.codeView.enabled) {
                        const { rawHtml } = editor.extensionStorage.codeView
                        editor.commands.setContent(rawHtml)
                        this.options.onChange?.(rawHtml)
                    } else {
                        editor.extensionStorage.codeView.rawHtml = editor.getHTML()
                    }
                    editor.extensionStorage.codeView.enabled = !editor.extensionStorage.codeView.enabled
                    return true
                },
        }
    },
})

export const CodeViewContent = ({ editor }: { editor: Editor }) => {
    const { classes } = useStyles()
    const [rawHtml, setRawHtml] = useState(editor.extensionStorage.codeView.rawHtml)
    const onChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        setRawHtml(e.target.value)
        editor.extensionStorage.codeView.rawHtml = e.target.value
    }
    return <Textarea className={classes.codeView} value={rawHtml} onChange={onChange} />
}

export const CodeViewButton = ({ editor }: { editor: Editor }) => (
    <RichTextEditor.Control
        onClick={() => editor.commands.toggleCodeView()}
        aria-label="Code view"
        title="Code view"
        active={editor?.extensionStorage.codeView.rawHtml}
    >
        <Icon icon="code" iconFamily="far" size="sm" />
    </RichTextEditor.Control>
)
